import Lenis from "lenis";

let lenis = null;

export const initLenis = () => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return () => {};
  lenis = new Lenis({ duration: 1.15, smoothWheel: true });
  let frame;
  const raf = (t) => {
    lenis.raf(t);
    frame = requestAnimationFrame(raf);
  };
  frame = requestAnimationFrame(raf);
  return () => {
    cancelAnimationFrame(frame);
    lenis.destroy();
    lenis = null;
  };
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: id === "top" ? 0 : -64 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const pauseScroll = (paused) => {
  if (!lenis) return;
  if (paused) lenis.stop();
  else lenis.start();
};
